import React from 'react';
import { TouchableOpacity } from 'react-native';
import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { red } from '@/shared/styles/colors';

interface CancelButtonProps {
  onCancel: () => void;
  consultationDate: Date;
  isCancelled: boolean;
  isStylist: boolean;
  isComplete: boolean;
}

const CancelButton = ({
  onCancel,
  isCancelled,
  isStylist,
  isComplete,
}: CancelButtonProps) => {
  if (isCancelled || isComplete) {
    return null;
  }

  return (
    <CancelContainer>
      <TouchableOpacity onPress={onCancel}>
        <CancelText>Cancel Session</CancelText>
      </TouchableOpacity>
      <DisclaimerText>
        {!isStylist &&
          'Heads up: If you miss your session without canceling at least 24 hours in advance, the full estimated price will apply.'}
      </DisclaimerText>
    </CancelContainer>
  );
};

const CancelContainer = styled.View({
  width: '100%',
  marginBottom: 22,
  alignItems: 'center',
});

const CancelText = styled(BodyText)({
  fontSize: 15,
  color: red,
  textDecorationLine: 'underline',
  fontWeight: 'bold',
  marginBottom: 2,
});

const DisclaimerText = styled(BodyText)({
  fontStyle: 'italic',
  fontWeight: 'bold',
  fontSize: 10,
  lineHeight: 14,
  textAlign: 'center',
  maxWidth: 300,
});

export default CancelButton;
